import AccountConsolidationRecordManager from './list'
import AccountConsolidationRecordDetail from './detail'
import AccountConsolidationRecordAdd from './add'

export {
  AccountConsolidationRecordManager,
  AccountConsolidationRecordDetail,
  AccountConsolidationRecordAdd,
}
